import { protectedApi } from "../common/protectedApi";
import { APIS } from "../constants/apiConstant";
import { FINANCE_SALARY_COMPANIES_UPDATED_EVENT } from "./financeSalaryCompaniesStorage";

/** Same as payslip company details: compressed image kept as data URL in DB (no Cloudinary upload). */
const resolveSignatureForSave = (form = {}) => {
  const dataUrl = String(form.signatureDataUrl || "").trim();
  const httpsUrl = String(form.signatureUrl || "").trim();
  if (dataUrl.startsWith("data:image/")) return dataUrl;
  if (httpsUrl.startsWith("http://") || httpsUrl.startsWith("https://")) return httpsUrl;
  return dataUrl || httpsUrl || null;
};

export const mapFinanceSalaryCompanyFromApi = (row) => {
  if (!row) return null;
  const signatureUrl = row.signatureUrl || "";
  return {
    id: row.id,
    companyName: row.companyName || "",
    ownerName: row.ownerName || "",
    contactNumber: row.contactNumber || "",
    emailId: row.emailId || "",
    companyAddress: row.companyAddress || "",
    signatureUrl,
    signatureFileName: row.signatureFileName || "",
    signatureDataUrl: signatureUrl,
    createdAt: row.createdAt,
    updatedAt: row.updatedAt,
  };
};

export const fetchFinanceSalaryCompanies = async () => {
  const response = await protectedApi({
    url: APIS.FINANCE_SALARY_COMPANIES,
    method: "GET",
  });
  const companies = response?.data?.data?.companies || [];
  return companies.map(mapFinanceSalaryCompanyFromApi).filter(Boolean);
};

export const fetchFinanceSalaryCompanyById = async (companyId) => {
  if (companyId == null || companyId === "") return null;
  const url = APIS.FINANCE_SALARY_COMPANY.replace(":companyId", String(companyId));
  const response = await protectedApi({ url, method: "GET" });
  return mapFinanceSalaryCompanyFromApi(response?.data?.data?.company);
};

const buildCompanyPayload = (form) => ({
  companyName: form.companyName,
  ownerName: form.ownerName,
  contactNumber: form.contactNumber,
  emailId: form.emailId,
  companyAddress: form.companyAddress,
  signatureUrl: resolveSignatureForSave(form),
  signatureFileName: form.signatureFileName || null,
});

export const createFinanceSalaryCompanyApi = async (form) => {
  const response = await protectedApi({
    url: APIS.FINANCE_SALARY_COMPANIES,
    method: "POST",
    data: buildCompanyPayload(form),
  });

  const company = mapFinanceSalaryCompanyFromApi(response?.data?.data?.company);
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(FINANCE_SALARY_COMPANIES_UPDATED_EVENT));
  }
  return company;
};

export const updateFinanceSalaryCompanyApi = async (companyId, form) => {
  const url = APIS.FINANCE_SALARY_COMPANY.replace(":companyId", String(companyId));
  const response = await protectedApi({
    url,
    method: "PUT",
    data: buildCompanyPayload(form),
  });

  const company = mapFinanceSalaryCompanyFromApi(response?.data?.data?.company);
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(FINANCE_SALARY_COMPANIES_UPDATED_EVENT));
  }
  return company;
};

export const deleteFinanceSalaryCompanyApi = async (companyId) => {
  const url = APIS.FINANCE_SALARY_COMPANY.replace(":companyId", String(companyId));
  await protectedApi({ url, method: "DELETE" });
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(FINANCE_SALARY_COMPANIES_UPDATED_EVENT));
  }
};
